'use client'

import { memo } from 'react'

import { TMSReservationSlotData } from 'modules/delivery'

import CartAddDeliveryAddress from './CartAddDeliveryAddress'
import CartTmsDeliveryDate from './CartDeliverySlotPicker'

interface TmsDeliverySelectionProps {
  isInDropdown: boolean
  hasCoordinates: boolean
  reservationSlotData?: TMSReservationSlotData
  onEndReservation: () => void
  isPostalCodeAndCitySupported: boolean
}

const TmsDeliverySelection: React.FC<TmsDeliverySelectionProps> = ({
  isInDropdown,
  hasCoordinates,
  reservationSlotData,
  onEndReservation,
  isPostalCodeAndCitySupported
}) => {
  return (
    <>
      {!isInDropdown && <CartAddDeliveryAddress />}

      <CartTmsDeliveryDate
        handleEndReservation={onEndReservation}
        isInDropdown={isInDropdown}
        hasCoordinates={hasCoordinates}
        reservationSlotData={reservationSlotData}
        isPostalCodeAndCitySupported={isPostalCodeAndCitySupported}
      />
    </>
  )
}

export default memo(TmsDeliverySelection)
